import { createAsyncThunk } from '@reduxjs/toolkit';
import type { AppDispatch, RootState } from '.';

// have to define createAppAsyncThunk in this file to fix dependency warning
export const createAppAsyncThunk = createAsyncThunk.withTypes<{
  state: RootState;
  dispatch: AppDispatch;
  rejectValue: any;
}>();
